// extracted by mini-css-extract-plugin
module.exports = {"cta":"linkcta-module--cta--2eCm_","ctaLink":"linkcta-module--cta-link--3bWjl"};